import React, {createContext } from 'react'

export const FormErrorContext = createContext();

export const FormErrorContextProvider = (props) => {
    return (
        <FormErrorContext.Provider value={{ formErrors: props.formErrors }}>
            {props.children}
        </FormErrorContext.Provider>
    )
}
